// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-footer {
  background-color: var(--surface-dark);
  color: var(--text-on-dark);
  margin-top: 40px;
  padding-top: 20px;
}

.footer-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 32px;
  justify-content: space-between;
  padding: 40px 24px;
}

.footer-tagline {
  max-width: 320px;
  opacity: 0.85;
  margin: 8px 0 0;
  font-size: 0.9rem;
  font-style: italic;
}

.footer-social {
  margin-top: 16px;
}

.footer-bottom {
  text-align: center;
  padding: 14px;
  font-size: 0.8rem;
  border-top: 1px solid var(--border-on-dark);
  margin-top: 20px;
}

/* Coral clears AAA (7.83) on the dark footer. */
.footer-bottom a,
.footer-bottom a:visited {
  color: var(--text-accent-on-dark);
}

.footer-bottom a:hover {
  color: var(--text-on-dark);
}

/* Phones: the link gets its own line instead of a dangling separator. */
@media (max-width: 600px) {
  .footer-sep {
    display: none;
  }

  .footer-bottom a {
    display: block;
    margin-top: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;;EAEE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":[".site-footer {\n  background-color: var(--surface-dark);\n  color: var(--text-on-dark);\n  margin-top: 40px;\n  padding-top: 20px;\n}\n\n.footer-inner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 32px;\n  justify-content: space-between;\n  padding: 40px 24px;\n}\n\n.footer-tagline {\n  max-width: 320px;\n  opacity: 0.85;\n  margin: 8px 0 0;\n  font-size: 0.9rem;\n  font-style: italic;\n}\n\n.footer-social {\n  margin-top: 16px;\n}\n\n.footer-bottom {\n  text-align: center;\n  padding: 14px;\n  font-size: 0.8rem;\n  border-top: 1px solid var(--border-on-dark);\n  margin-top: 20px;\n}\n\n/* Coral clears AAA (7.83) on the dark footer. */\n.footer-bottom a,\n.footer-bottom a:visited {\n  color: var(--text-accent-on-dark);\n}\n\n.footer-bottom a:hover {\n  color: var(--text-on-dark);\n}\n\n/* Phones: the link gets its own line instead of a dangling separator. */\n@media (max-width: 600px) {\n  .footer-sep {\n    display: none;\n  }\n\n  .footer-bottom a {\n    display: block;\n    margin-top: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
